import React from 'react'
import { Box, Tooltip, TooltipProps } from '@mui/material'

interface Props {
  title: TooltipProps['title']
  children: React.ReactElement
}

export const TooltipChip: React.FC<Props> = ({ title, children }) => (
  <Tooltip arrow title={title}>
    <Box component="span" sx={{ display: 'inline-flex' }}>
      {children}
    </Box>
  </Tooltip>
)
